<template>
    <div>
        <AntdvInput
            v-if="!data.open"
            :value="inputValueComputed"
            v-maska="maskComputed"
            :placeholder="placeholderComputed"
            :disabled="disabled"
            :size="size"
            @update:value="onUpdateInputValue"
            @blur="onBlurInputValue"
        >
            <template v-slot:suffix>
                <CIcon file="close.svg" v-if="value && !disabled" class="mr-2" @click="() => onUpdateValue(null)"></CIcon>
                <CIcon file="calendar.svg" v-if="!disabled" @click="() => (data.open = true)"></CIcon>
            </template>
        </AntdvInput>
        <DatePicker
            v-else
            :class="`w-100 custom-format format-${format}`"
            :value="value"
            @update:value="onUpdateValue"
            :format="format"
            :valueFormat="valueFormat"
            :inputReadOnly="true"
            :showTime="showTime"
            :open="data.open"
            :mode="data.mode"
            :placeholder="label"
            :disabled="disabled"
            :dropdownClassName="`custom-format format-${format}`"
            :size="size"
            @change="onChange"
            @openChange="onOpenChange"
            @panelChange="onPanelChange"
        ></DatePicker>
    </div>
</template>

<script>
import { computed, defineAsyncComponent, defineComponent, reactive, watchEffect } from "vue";
import { Input, DatePicker } from "ant-design-vue";
import moment from "moment";
import {
    formatInputValue,
    formatToMask,
    formatToPlaceholder,
    onUpdateInputValue,
    onBlurInputValue,
    onUpdateValue,
    createOnChange,
    createOnOpenChange,
    createOnPanelChange,
} from "./picker.logic";

export default defineComponent({
    components: {
        AntdvInput: Input,
        DatePicker,
        CIcon: defineAsyncComponent(() => import("../../../icon/CIcon")),
    },
    props: {
        value: {},
        format: {
            default: (props) =>
                !props.showTime
                    ? "DD/MM/YYYY"
                    : props.showTime === true || props.showTime.format?.includes("ss")
                    ? "DD/MM/YYYY HH:mm:ss"
                    : "DD/MM/YYYY HH:mm",
        },
        valueFormat: {
            default: (props) =>
                !props.showTime
                    ? "YYYY-MM-DD"
                    : props.showTime === true || props.showTime.format?.includes("ss")
                    ? "YYYY-MM-DD[T]HH:mm:ssZ"
                    : "YYYY-MM-DD[T]HH:mm:00Z",
        },
        label: {},
        disabled: {},
        showTime: { default: false },
        size: { default: "default" },
    },
    emits: ["update:value"],
    setup(props, { emit }) {
        const data = reactive({
            inputValue: "",
            open: false,
            mode: "date",
        });
        watchEffect(() => {
            const value = moment(props.value, props.valueFormat, true);
            if (value.isValid()) {
                data.inputValue = value.format(props.format);
            } else {
                data.inputValue = null;
            }
        });
        const inputValueComputed = computed(() => formatInputValue(data.inputValue, props.format));
        const maskComputed = computed(() => formatToMask(props.format));
        const placeholderComputed = computed(() => formatToPlaceholder(props.format));
        return {
            data,
            inputValueComputed,
            maskComputed,
            placeholderComputed,
            onUpdateInputValue: onUpdateInputValue({ data, format: props.format, valueFormat: props.valueFormat, emit }),
            onBlurInputValue: onBlurInputValue({ data, format: props.format, valueFormat: props.valueFormat, emit }),
            onUpdateValue: onUpdateValue({ emit }),
            onChange: createOnChange({ props, data }),
            onOpenChange: createOnOpenChange({ data }),
            onPanelChange: createOnPanelChange({ data }),
        };
    },
});
</script>
